const CONTACT_PATH = '/contact/';

export function getContactFormUri(slug: string): string {
  return `${CONTACT_PATH}${slug.replace(/^\//, '')}`;
}
